import React, { Component } from 'react';
import Vas from '../Vas';
import { LinkButton } from 'component-lib';

class NoPayment extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};

    }

   render()
    {
        return ( <div className={"contractContainer"}>
          <div className={"form"}>
            <table style={{width:'500px'}}>
              <thead>
                <tr>
                  <th colSpan={2}><h2><div style={{ textAlign:"justify" }}>{Vas.Resources.Labels["NoPayment"]}</div></h2></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ fontSize:'18px' }}>
                    <LinkButton 
                      Text={Vas.Resources.Labels["CreatePayment"]} 
                      Id={"LinkLogin"} 
                      OnClick={()=>{
                        Vas.GetView('CreatePayment', { CustomerId:this.props.match.params.CustomerId, NewContract: true }, true); }} />
                  </td>
                </tr>
              </tbody>
            </table> 
          </div>
        </div>);
    }
}
export default NoPayment;
